import googleMapLoader from 'google-map-react/lib/loaders/google_map_loader';
import { Sdk, AutocompleteService, PlacesService } from 'ha/types/GoogleMaps';

interface Config {
  key: string;
  language: string;
}

export default ({ key, language }: Config) => {
  let autocompleteService: Promise<AutocompleteService>;
  let placesService: PlacesService;
  let sdk: Sdk;

  function createAutocompleteService() {
    const initializer = googleMapLoader({
      key,
      language,
      libraries: 'places',
    });

    return initializer.then((newSdk: Sdk) => {
      sdk = newSdk;
      placesService = new sdk.places.PlacesService(
        document.createElement('div'),
      );
      return new sdk.places.AutocompleteService();
    });
  }

  return {
    init: () => {
      if (!autocompleteService) {
        autocompleteService = createAutocompleteService();
      }

      return autocompleteService;
    },
    getPlacesService: () => placesService,
    getSdk: () => sdk,
  };
};
